import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ariaLabelForRadioSelectField: {
		id: 'issue.views.field.team.radioSelect.ariaLabel',
		defaultMessage: 'Radio Select Field',
		description: 'ariaLabel for radio select field',
	},
});
